type Listener<T> = (payload: { state: T; action: string }) => void;

export abstract class StoreBase<T> {
    isInitialized: Promise<void>;

    protected state: T;
    protected listeners: Listener<T>[] = [];
    protected resolveInitialize!: () => void;

    constructor(initialState: T) {
        this.state = initialState;
        this.isInitialized = new Promise((resolve) => {
            this.resolveInitialize = resolve;
        });
    }

    abstract initialize(): Promise<void>;

    async startInitialization(): Promise<void> {
        await this.initialize();
        this.resolveInitialize();
    }

    subscribe(callback: Listener<T>): () => void {
        this.listeners.push(callback);
        return () => {
            this.listeners = this.listeners.filter((listener) => listener !== callback);
        };
    }

    protected notifyListeners(action: string): void {
        this.listeners.forEach((listener) =>
            listener({
                state: this.state,
                action,
            }),
        );
    }

    notify(action: string, state: Partial<T>): void {
        this.state = { ...this.state, ...state } as T;

        console.log(`Action: ${action}`, state);

        this.notifyListeners(action);
    }
}
